<template>
  <div class="col">
    <div class="sidebar-widget" id="form_container">
      <h3>Have a Question For Our Experts?</h3>
      <h4>If you would like to submit a question for the panel discussion, please use this form.</h4>
      <p>Note: Please do not use this form for technical support. If you are having trouble, please <router-link to="/faq">review the FAQ section for common questions and answers</router-link>.</p>
      <form id="email_form">
        <input type="text" id="Name" name="Name" required placeholder="Enter your name">
        <textarea id="Message" name="Message" rows="6" maxlength="1000" required placeholder="Please type your question here."></textarea>
        <input type="submit" value="Submit Question">
      </form>
    </div>
    <aside class="sidebar-widget" id="status_container">
      <div id="statusMessage"></div>
    </aside>
    <aside class="sidebar-widget">
      <h3>Full Schedule</h3>
      <p>Please <router-link to="/presentations">click here</router-link> to view the full schedule for the 2021 Investment U Conference</p>
    </aside>
    <aside class="sidebar-widget">
      <h3>Having Trouble?</h3>
      <p>Please <router-link to="/faq">review the FAQ section for common questions and answers</router-link>.</p>
      <p>If you continue to have any issues with the Live Stream event please email here:</p>
      <p><a href="mailto:videoissue@oxfordclub.com">videoissue@oxfordclub.com</a></p>
      <p>Or call us at <a href="tel:888-903-2227">888-903-2227</a> (U.S.) or <a href="tel:1-443-353-4390">+1-443-353-4390</a> (International).</p>
    </aside>
  </div>
</template>

<script>
import helpers from '../helpers';
import $ from 'jquery';

export default {
  name: 'Sidebar',
  data() { return { year: helpers.getYear(), } },
};

$(document).ready(function() {
	const email_form = $('#email_form')
	email_form.submit(function(e) {
		e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()
		const name = $(this).find('#Name').val()
		const message = $(this).find('#Message').val()
		$.post(
			'https://investmentuconference.com/email/contact.php',
			{ "Name": name, "Message": message }
		)
		.done(
      $('#form_container').fadeOut(),
      $('#statusMessage').append('<h3>Thank you for submitting your question!</h3>'),
      $('#status_container').fadeIn().delay(10000).fadeOut()
    )
		// .fail($('#statusMessage').append('<h3>Failure!</h3>')	// see above
	})
})
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#status_container {
  display: none
}
.sidebar-widget {
  border-radius: .25rem;
  background-color: #f9f9f9;
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
}
.sidebar-widget > h3 {
  margin: 0 0 0.5em;
  font-size: 24px;
}
.sidebar-widget > h4 {
  margin: 0 0 0.25em;
  font-size: 18px;
}
.sidebar-widget > p {
  margin: 0 0 10px;
}
.sidebar-widget > p > a {
  color: #282472;
  font-weight: bold;
  text-decoration: none;
}
.sidebar-widget form{
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: flex-start;
  width: 100%;
}
.sidebar-widget form input, .sidebar-widget form textarea {
  border: 1px solid #ddd;
  border-radius: .25rem;
  margin: .5rem 0;
  padding: .75rem;
  font-size: 1rem;
}
.sidebar-widget form input[type='text'] {
  width: 300px;
  max-width: 100%;
}
.sidebar-widget form textarea {
  width: 600px;
  max-width: 100%;
}
.sidebar-widget form input[type='submit'] {
  background-color: #0B202B;
  border-top: 5px solid #6DC5CB;
  color: #6DC5CB;
  font-family: 'Montserrat', sans-serif;
  font-size: 1.25rem;
  font-weight: 800;
  text-transform: uppercase;
  width: 300px;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue